// extracted by css-extract-rspack-plugin
export default {"cls1":"Home-cls1_m3K","cls2":"Home-cls2_eW_ Home-cls1_m3K"};